<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline"> Matricular Pré-Matrícula </v-card-title>

      <v-card-text>
        <v-alert v-if="duplicidades.length > 1" type="warning" dense>
          Foram encontradas {{ duplicidades.length }} pré-matrículas para este CPF. Selecione qual
          deseja matricular.
        </v-alert>
        <div v-if="duplicidades.length > 1">
          <h3 class="mb-3">Selecione a pré-matrícula a matricular:</h3>
          <v-radio-group v-model="prematriculaSelecionadaId">
            <v-radio v-for="dup in duplicidades" :key="dup.id" :value="dup.id">
              <template v-slot:label>
                <div>
                  <strong>{{ dup.nome || (dup.aluno ? dup.aluno.nomecompleto : "") }}</strong>
                  <v-chip x-small :color="getChipColor(dup)" dark class="ml-2">
                    {{ getTipoLabel(dup) }}
                  </v-chip>
                  <br />
                  <small
                    >Turma: {{ dup.turma ? dup.turma.descricao : "" }} - Etapa:
                    {{ dup.serie ? dup.serie.descricao : "" }}</small
                  ><br />
                  <small>{{ dup.escola_descricao ?? "- - -" }}</small
                  ><br />
                  <small class="grey--text">Criada em: {{ formatarData(dup.created_at) }}</small>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>

        <div v-else>
          <p>
            Deseja confirmar a matrícula de
            <strong>{{
              prematricula.nome || (prematricula.aluno ? prematricula.aluno.nomecompleto : "")
            }}</strong>
            <v-chip x-small :color="getChipColor(prematricula)" dark class="ml-2">
              {{ getTipoLabel(prematricula) }}
            </v-chip>
            ?
          </p>
          <p>
            <strong>Turma:</strong> {{ prematricula.turma ? prematricula.turma.descricao : ""
            }}<br />
            <strong>Etapa:</strong> {{ prematricula.serie ? prematricula.serie.descricao : "" }}
          </p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fechar" :disabled="loading"> Cancelar </v-btn>
        <v-btn
          color="primary"
          @click="confirmarMatricula"
          :loading="loading"
          :disabled="duplicidades.length > 1 && !prematriculaSelecionadaId"
        >
          Confirmar Matrícula
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ModalMatricular",
  props: {
    prematricula: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      loading: false,
      duplicidades: [],
      prematriculaSelecionadaId: null,
    };
  },
  computed: {
    prematriculaSelecionadaInfo() {
      if (!this.prematriculaSelecionadaId) return null;
      return this.duplicidades.find((d) => d.id === this.prematriculaSelecionadaId);
    },
  },
  methods: {
    isAEE(prematricula) {
      if (!prematricula) return false;
      const tipoAtendimento =
        prematricula.tipo_de_atendimento || prematricula.turma?.tipo_de_atendimento;
      return tipoAtendimento === "Atendimento educacional especializado (AEE)";
    },
    isAtividadeComplementar(prematricula) {
      if (!prematricula) return false;
      const tipoAtendimento =
        prematricula.tipo_de_atendimento || prematricula.turma?.tipo_de_atendimento;
      return tipoAtendimento === "Atividade complementar";
    },
    getTipoLabel(prematricula) {
      if (this.isAEE(prematricula)) return "AEE";
      if (this.isAtividadeComplementar(prematricula)) return "Atividade Complementar";
      return "Regular";
    },
    getChipColor(prematricula) {
      if (this.isAEE(prematricula)) return "purple";
      if (this.isAtividadeComplementar(prematricula)) return "green";
      return "blue";
    },
    async buscarDuplicidades() {
      this.loading = true;
      try {
        this.duplicidades = await this.$services.preMatriculasService.buscarDuplicidades(
          this.prematricula.cpf
        );

        if (this.duplicidades.length === 1) {
          this.prematriculaSelecionadaId = this.duplicidades[0].id;
        } else if (this.duplicidades.length > 1) {
          this.prematriculaSelecionadaId = this.prematricula.id;
        }
      } catch (error) {
        this.$toast.error("Erro ao buscar duplicidades");
      } finally {
        this.loading = false;
      }
    },
    async confirmarMatricula() {
      this.loading = true;
      try {
        await this.$services.preMatriculasService.matricular(this.prematriculaSelecionadaId);

        this.$toast.success("Matrícula realizada com sucesso!");
        this.$emit("sucesso");
        this.fechar();
      } catch (error) {
        this.$toast.error(error.message || "Erro ao realizar matrícula");
      } finally {
        this.loading = false;
      }
    },
    formatarData(data) {
      if (!data) return "";
      return new Date(data).toLocaleString("pt-BR");
    },
    fechar() {
      this.dialog = false;
      this.$emit("close");
    },
  },
  mounted() {
    this.buscarDuplicidades();
  },
};
</script>
